import { Avatar } from "@amzn/stencil-react-components/avatar";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Link } from "@amzn/stencil-react-components/link";
import { Text } from "@amzn/stencil-react-components/text";
import React, { FC, ReactNode } from "react";

export interface CommentBubbleProps {
  authorAlias: string;
  authorName: string;
  date: string;
  text: string;
  actions?: ReactNode;
}

export const CommentBubble: FC<CommentBubbleProps> = ({ authorAlias, authorName, date, text, actions }) => (
  <Row gridGap="dimensions.spacing.300" alignItems="flex-start">
    <Avatar fullName={authorName} username={authorAlias} showFullName={false} showUsername={false} />
    <Col gridGap="dimensions.spacing.100" flex={1}>
      <Row gridGap="dimensions.spacing.200" alignItems="center">
        <Text fontSize="T200" fontWeight="bold">
          {authorName}
        </Text>
        <Text fontSize="T100" color="color.text.secondary">
          {date}
        </Text>
      </Row>
      <Link href={`https://phonetool.amazon.com/users/${authorAlias}`} target="_blank" rel="noopener noreferrer">
        <Text fontSize="T100" color="color.text.secondary">
          @{authorAlias}
        </Text>
      </Link>
      <Text fontSize="T200">{text}</Text>
      {actions}
    </Col>
  </Row>
);
